<template>
	<article class="error_wrap">
		<div class="error_inner">
			<p>ERROR</p>
			<span>Not Found<br />Please contact support@bwisesoft.com</span>
			<a href="javascript:;" class="normal_bt error_home_bt" onClick="history.go(-1);">To previous page</a>
		</div>
	</article>
</template>

<script>
export default {};
</script>

<style scoped src="@/assets/css/error.css"></style>
